(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("antd"), require("ecCom"), require("mobx"), require("loadjs"));
	else if(typeof define === 'function' && define.amd)
		define(["antd", "ecCom", "mobx", "loadjs"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("antd"), require("ecCom"), require("mobx"), require("loadjs")) : factory(root["antd"], root["ecCom"], root["mobx"], root["loadjs"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_43__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_49__, __WEBPACK_EXTERNAL_MODULE_13__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition